import React from "react";
import "./index.scss";
import Dialog from "@mui/material/Dialog";
import downloadImageIcon from "../../../Assests/Images/uploadImage.svg";
import CloseIcon from "../../../Assests/Images/Close.svg";
import Button from "../../../SharableInputs/Button";

const DocPreviewModal = ({
  isOpen,
  close,
  confirm,
  fileSrc,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={close}
      className={`custom-modal-container`}
    >
      <img
        src={CloseIcon}
        alt="logo"
        width={85}
        height={20}
        onClick={close}
        role="button"
        className="w-auto align-self-end x-icon"
      />
      <p className={`m-0 header`}>Document Viewer</p>
      <div className="d-flex flex-column gap-3 preview-wrapper align-items-center">
        <img src={fileSrc} alt="document-preview" width={752} height={364} className="mt-3 preview-img"/>
        <div className="d-flex align-self-end  gap-3">
          <Button
            primary={true}
            type="button"
            label="Download"
            onClick={confirm}
            icon={
                <img
                  src={downloadImageIcon}
                  alt="downloadImageIcon"
                  width={20}
                  height={20}
                  className="download-img"
                />
              }
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DocPreviewModal;
